import React from 'react';
import { GDPRCheckBoxField } from '../components';

export const chooseDocumentFormatter = (value, record) => {
  return <GDPRCheckBoxField record={record} />;
};
